import { defineStore, acceptHMRUpdate } from "pinia";
import Api from "src/utils/api";

export const useAttachmentsStore = defineStore("attachments_store", {
  persist: true,
  state: () => ({
    attachments: []
  }),
  actions: {
    async insertAttachment(data) {
      const response = await Api.Attachments.insertAttachment(data);
      return response;
    },
    async getAttachment(id, getLocalAttachments = false) {
      const response = await Api.Attachments.getAttachment(
        id,
        getLocalAttachments
      );
      return response;
    }
  },
  $reset() {}
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAttachmentsStore, import.meta.hot));
}
